import { PureComponent } from "react";
import { WorkflowScreenService } from "../../../services/workflow-screen-service";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { KMainFunctions } from "../../../shared/utility/main-functions";
import { KModal } from "../../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../../ui-kit/k-modal/k-modal-footer";
import KuikaModalIconWrapper from "../../ui-kit/kuika-modal-icon-wrapper/kuika-modal-icon-wrapper";
import KuikaH5 from "../../ui-kit/typography/H5/H5";
import "./step-screen-form-wizard.scss";

export interface IStepScreenModalUnlinkScreenModalProps {
  isOpen: boolean;
  onClose: (isUnlinked: boolean) => void;
  step: {
    processId: string;
    stepId: string;
    screenId: string;
  };
  reloadScreen: () => Promise<void>;
}

export interface IStepScreenModalUnlinkScreenModalState {
  isUnlinking: boolean;
}

class StepScreenModalUnlinkScreenModal extends PureComponent<
  IStepScreenModalUnlinkScreenModalProps & IWithSDProps,
  IStepScreenModalUnlinkScreenModalState
> {
  constructor(props) {
    super(props);
    this.state = {
      isUnlinking: false
    };
  }

  onClickUnlink = async () => {
    try {
      this.setState({ isUnlinking: true });
      await WorkflowScreenService.UnlinkScreen({
        processId: this.props.step.processId,
        stepId: this.props.step.stepId,
        screenId: this.props.step.screenId
      });
      await this.props.reloadScreen();
      this.setState({ isUnlinking: false }, () => this.props.onClose(true));
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    } finally {
      this.setState({ isUnlinking: false });
    }
  };

  onClose = () => {
    if (this.state.isUnlinking) {
      return;
    }

    this.props.onClose(false);
  };

  render() {
    return (
      <KModal
        header="Unlink Screen"
        showModal={this.props.isOpen}
        closeModal={this.onClose}
        width={480}
        className="kuika-unlink-screen"
        footer={
          <KModalFooter
            submitLabel="Unlink"
            submitTone="danger"
            submitTestId="unlinkScreenConfirmButton"
            onSubmit={this.onClickUnlink}
            onCancel={this.onClose}
            loading={this.state.isUnlinking}
          />
        }
      >
        <div className="kuika-unlink-screen__header">
          <KuikaModalIconWrapper iconName="unlink" intent="destructive" />
          <KuikaH5 className="kuika-unlink-screen__title">Unlink Screen</KuikaH5>
        </div>
        <div className="kuika-unlink-screen__body">
          <div>
            This operation will make the screen unmanaged. Which means the changes on the step will not be reflected
            automatically to the screen by Kuika.
          </div>
          <div>You will have to manually edit the screen to conform with the changes on the step.</div>
          <div>Are you sure you want to continue?</div>
        </div>
      </KModal>
    );
  }
}

const stepScreenModalUnlinkScreenModal = withSD<IStepScreenModalUnlinkScreenModalProps>(
  StepScreenModalUnlinkScreenModal
);
export { stepScreenModalUnlinkScreenModal as StepScreenModalUnlinkScreenModal };
